import { useNavigate } from 'react-router-dom';
import { useSubscriptionStore } from '../store/subscriptionStore';

const LimitExceededModal = ({ isOpen, onClose, limitType = 'video' }) => {
  const navigate = useNavigate();
  const { subscription, plans } = useSubscriptionStore();

  if (!isOpen) return null;

  const limitTypeText = limitType === 'video' ? 'парсинга видео' : 'AI запросов';
  const currentPlanIndex = plans.findIndex(p => p.id === subscription?.plan);
  const nextPlan = plans[currentPlanIndex + 1];

  const handleUpgrade = () => {
    onClose();
    navigate('/subscription');
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Overlay */}
        <div
          className="fixed inset-0 transition-opacity bg-slate-900 bg-opacity-75"
          onClick={onClose}
        />

        {/* Modal */}
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left flex-1">
                <h3 className="text-lg leading-6 font-medium text-slate-900">
                  Превышен лимит {limitTypeText}
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-slate-500">
                    Вы исчерпали лимит {limitTypeText} за этот месяц.
                    {subscription && (
                      <> Ваш текущий тариф <span className="font-semibold capitalize">{subscription.plan === 'free' ? 'Бесплатный' : subscription.plan}</span> включает:
                      </>
                    )}
                  </p>

                  {subscription && (
                    <div className="mt-3 p-3 bg-slate-50 rounded-lg">
                      <div className="space-y-1 text-sm">
                        <div className="flex justify-between">
                          <span className="text-slate-600">Парсинг видео:</span>
                          <span className="font-medium">
                            {subscription.videoUsed.toLocaleString()} / {subscription.videoLimit.toLocaleString()}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-slate-600">AI запросы:</span>
                          <span className="font-medium">
                            {subscription.aiUsed.toLocaleString()} / {subscription.plan === 'business' ? '∞' : subscription.aiLimit.toLocaleString()}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  {nextPlan && (
                    <div className="mt-4 p-4 bg-brand-lime/10 rounded-lg border border-brand-lime/30">
                      <p className="text-sm font-medium text-slate-900 mb-2">
                        Перейти на тариф «{nextPlan.name}»
                      </p>
                      <ul className="space-y-1 text-xs text-slate-600">
                        <li>✓ {nextPlan.videoLimit.toLocaleString()} парсингов видео в месяц</li>
                        <li>✓ {nextPlan.aiLimit ? nextPlan.aiLimit.toLocaleString() : 'Неограниченно'} AI запросов</li>
                        <li>✓ Все возможности тарифа «{nextPlan.name}»</li>
                      </ul>
                      <p className="mt-2 text-sm font-bold text-brand-lime-800">
                        {nextPlan.price} ₽/мес
                      </p>
                    </div>
                  )}

                  {!nextPlan && subscription?.plan !== 'business' && (
                    <p className="mt-3 text-sm text-slate-600">
                      Лимиты обновятся {(subscription?.renewDate ? new Date(subscription.renewDate) : new Date()).toLocaleDateString()}.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="bg-slate-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse gap-2">
            <button
              onClick={handleUpgrade}
              className="w-full inline-flex justify-center rounded-lg border border-transparent shadow-sm px-4 py-2 bg-brand-lime text-base font-bold text-brand-black hover:bg-brand-lime-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-lime sm:ml-3 sm:w-auto sm:text-sm"
            >
              Перейти к подпискам
            </button>
            <button
              onClick={onClose}
              className="mt-3 w-full inline-flex justify-center rounded-lg border border-slate-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-slate-700 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-lime sm:mt-0 sm:w-auto sm:text-sm"
            >
              Закрыть
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LimitExceededModal;
